<template>
  <div class="large-text__main" v-html="content"></div>
</template>

<style scoped>
.large-text__main {
  margin: 40px 0;
  width: 100%;
  font-size: 48px;
  color: #000000;
}

@media screen and (max-width: 600px) {
  .large-text__main {
    margin: 0;
    font-size: 24px;
  }
}
</style>

<script>
export default {
  title: "LargeText",
  props: {
    content: String
  }
};
</script>
